import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    TelNumber: {
        validations: [
          { type: 'required', message: 'Please fill in required field.' },
            { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
        ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' },
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    SiteName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
              {
              type: 'text',
              size: 'Medium',
              label: 'Phone Number:*',
              mapping: 'TelNumber'
          }
      ]
      },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Type:*',
              options: [
                { label: 'Corporate Event', value: 'Corporate Event' },
                { label: 'Wedding', value: 'Wedding' },
                { label: 'Graduation', value: 'Graduation' },
                { label: 'Family Gathering/Party', value: 'Family Gathering/Party' },
                { label: 'Pig Roast', value: 'Pig Roast' },
                { label: 'Clam Bake', value: 'Clam Bake' },
                { label: 'Food Truck', value: 'Food Truck' },
                { label: 'Other', value: 'Other' },
              ],
              mapping: 'theme'
            }
          ]
        },
        {
          fields: [
            {
               type: 'text',
               size: 'Medium',
               label: 'Approximately How Many People?:*',
               mapping: 'plannedguestcount'
             }
           ]
         },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date:*',
              mapping: 'eventDate'
            }
          ]
        },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Name of Venue:*',
                mapping: 'SiteName'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'Notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Empire Foods II Contact Form',
    formId: '789',
    clientKey: 'E01EF4C7-20F7-4A6B-8B86-5D1941707F36',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
